const EMPTY_DISPLAY_TOKENS = new Set([
  '',
  '-',
  '—',
  'n/a',
  'na',
  'null',
  'undefined',
]);

/**
 * Returns true when a value is meaningful for table rendering.
 * Treats common placeholder-like tokens and invalid primitive values as empty.
 */
export const hasDisplayValue = (value: unknown): boolean => {
  if (value == null) return false;

  if (typeof value === 'string') {
    const normalized = value.trim().toLowerCase();
    return !EMPTY_DISPLAY_TOKENS.has(normalized);
  }

  if (typeof value === 'number') {
    return Number.isFinite(value);
  }

  if (value instanceof Date) {
    return !Number.isNaN(value.getTime());
  }

  if (Array.isArray(value)) {
    return value.length > 0;
  }

  if (typeof value === 'object') {
    return Object.keys(value as Record<string, unknown>).length > 0;
  }

  return true;
};
